export default __webpack_public_path__ + "static/media/hair-4-2.d89c0ade.svg";